<template>
	<div class="container-inputs">
		<div v-for="(step, index) in steps" :key="index" class="row-step" :class="{current: index === currentStep, checked: index < currentStep}" @click.stop="stepClicked(index)">
			<div class="content">
				<h4>{{ step.title }}</h4>
				<p>{{ step.description }}</p>
			</div>
			<div class="input-icon">
				<img :src="step.image" alt="icon step">
			</div>
			<div class="step-indicator"></div>
		</div>
	</div>
</template>
<script>
import {useLanguageStore} from "@/shared/stores";
export default {
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString};
	},
	name: "StepForm",
	emits: ["changed-current-step"],
	props: {
		steps: {
			type: Array,
			required: true,
			validator(value) { return value && value.every(v => { return v.title && v.description && v.image; }); },
		},
		currentStep: {type: Number, default: 0}
	},
	methods: {
		stepClicked(index) {
			if(index <= this.currentStep) {
				this.$emit("changed-current-step", index);
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.container-inputs {
	padding-top: 30px;
	border-right: 1px solid #9eb6da;
	min-width: 200px;
	.row-step {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 30px;
		&:last-child {
			padding-bottom: 30px;
			margin-bottom: 0;
		}
		.content {
			text-align: end;
			width: 44%;
			h4 {
				font-size: 14px;
				line-height: 16px;
				color: #4E4E4E;
			}
			p {
				margin-top: 5px;
				font-size: 10px;
				line-height: 12px;
				color: #4e4e4e;
			}
		}
		.input-icon {
			background-color: #C1D4E8;
			border-radius: 13px;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-left: 20px;
			width: 45px;
			height: 45px;
			transition: background-color .2s $transition;
			img {
				object-fit: contain;
				width: 22px;
				height: 22px;
			}
		}
		.step-indicator {
			position: relative;
			width: 15px;
			height: 15px;
			border-radius: 10px;
			background-color: #C1D4E8;
			margin-left: 30px;
			margin-right: -8px;
			transition: background-color .2s $transition;
			&:after {
				content: '';
				position: absolute;
				width: 7px;
				height: 7px;
				border-radius: 4px;
				background-color: #FFFFFF;
				top: 4px;
				left: 4px;
			}
		}
		&.current {
			.input-icon {
				background-color: $primary;
			}
			.step-indicator {
				background-color: $primary;
			}
		}
		&.checked {
			.input-icon {
				background-color: #28edbf;
			}
			.step-indicator {
				background-color: #28edbf;
			}
		}
	}
}
</style>